import "@/App.css";
import "@/theme-pipoca.css";
import "@/theme-zap.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ChatPage from "./pages/ChatPage";
import WaChatPage from "./pages/WaChatPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import SupportPage from "./pages/SupportPage";
import { Toaster } from "./components/ui/sonner";
import { BrandProvider } from "./context/brand";
import { BRANDS, DEFAULT_BRAND } from "./lib/brands";
import { DesktopGate } from "./components/chat/DesktopGate";

const funnel = (brand) => (
  <BrandProvider brand={brand} title="Atendimento"><DesktopGate>{brand.wa ? <WaChatPage /> : <ChatPage />}</DesktopGate></BrandProvider>
);
const support = (brand) => <BrandProvider brand={brand} title="Suporte"><DesktopGate><SupportPage /></DesktopGate></BrandProvider>;
const admin = (Page) => <BrandProvider brand={DEFAULT_BRAND} title="Painel"><Page /></BrandProvider>;

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={funnel(DEFAULT_BRAND)} />
        <Route path="/atendimento" element={support(DEFAULT_BRAND)} />
        {Object.values(BRANDS).map((b) => (
          <Route key={b.id} path={`/${b.id}`} element={funnel(b)} />
        ))}
        {Object.values(BRANDS).map((b) => (
          <Route key={`${b.id}-s`} path={`/${b.id}/atendimento`} element={support(b)} />
        ))}
        <Route path="/admin/login" element={admin(AdminLogin)} />
        <Route path="/admin" element={admin(AdminDashboard)} />
        <Route path="*" element={funnel(DEFAULT_BRAND)} />
      </Routes>
      <Toaster position="top-center" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
